/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class AssetPrintAPI
 * @hideconstructor
 * @classdesc API class to allow assets to implement independent functionality for printing
 */
define([], () => {
	class AssetPrintAPI {
		/**
		 * @public
		 * @function AssetPrintAPI#showContentsForPrint
		 * @param content.context the printing context
		 * @param {array} content.modelIds id's of the different page contents of the asset
		 * @param {string} content.layoutType  type of the layout
		 * @param {object} content.printPageSize the size of the pdf paper that the user chose
		 * @param {object} content.pageElement node referring to the root page element of the current view
		 * @description shows the contents of the current asset before printing
		 */
		showContentsForPrint() {}

		/**
		 * @public
		 * @function AssetPrintAPI#hideContentsAfterPrint
		 * @param {array} modelIds id's of the different page contents of the asset
		 * @param {object} pageElement node referring to the root page element of the current view
		 * @description hides the contents of the current asset after printing
		 */
		hideContentsAfterPrint() {}

		/**
		 * @function AssetPrintAPI#getOffScreenPageSize
		 * @description returns the off screen page size of the board
		 * @param {object} tab scene/tabs of the current asset
		 */
		getOffScreenPageSize() {}
	}

	return AssetPrintAPI;
});
